import { create } from 'zustand'

interface SearchModalStore {
  isOpen: boolean
  open: () => void
  close: () => void
}

export const useSearchModalStore = create<SearchModalStore>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}))
